module.exports = __webpack_public_path__ + "789774e3e10dc372523af30587350745.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/hotline4.png
// module id = 547
// module chunks = 21 77